import { ArrowBack, ArrowForward, Clear, ExpandMore, Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, CardContent, CardHeader, Grid, IconButton, ListItemText, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { makeStyles, styled } from '@mui/styles';
import axios from 'axios';
import { getDatabase, ref, remove, set } from 'firebase/database';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthStore } from '../../../../store/UserStore';
import { updateFirebasePencairan } from '../../../../utils/Firebase';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';

const useStyles = makeStyles({
    root: {
        position: "sticky",
        top: "5rem",
        minWidth: "275"
    }
});

const Item = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    // padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    // minHeight: 450,
    // maxHeight: 900, 
    // overflowY: "scroll"
}));

const FormAcc = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const classes = useStyles()
    const location = useLocation();
    const pencairan = location.state || null;
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);

    useEffect(() => {
        setBreadcrumbItem({ '/verif': 'Home', '/verif/terverifikasi_online': 'Terverifikasi Online', '': 'Periksa' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    useEffect(() => {
        updateLoket()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleBatal = () => {
        Swal.fire({
            title: 'Proses SP2D Dibatalkan?',
            text: "Masukkan Catatan Revisi",
            icon: 'warning',
            input: 'text',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Proses',
            cancelButtonText: 'Tutup',
            preConfirm: (revisi) => {
                setLoading(true);
                const frm = {
                    _method: "PUT",
                    no_spm: pencairan.no_spm,
                    progres: 2,
                    revisi: revisi
                };
                return axios.post(
                    base_url + '/verif/pencairan/update',
                    frm,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        setLoading(false);

                        Swal.fire({
                            icon: 'success',
                            title: 'Berhasil',
                            text: response.data.msg
                        })
                        setLoading(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                        setLoading(false);
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    const handleSesuai = () => {
        const post = {
            _method: 'PUT',
            no_spm: pencairan.no_spm,
            progres: 4
        }
        setLoading(true);
        axios.post(
            base_url + '/verif/pencairan/update',
            post,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);
                console.log(response);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })
                deleteLoket();
                updateProsesSP2D(response.data.prosesSP2D)
                updateFirebasePencairan(pencairan, post.progres)
                setLoading(false);
                navigate(-1);
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false);
            })
    }

    const updateLoket = () => {
        const db = getDatabase();
        set(ref(db, 'verifikasi/' + decryptedUser.nip), {
            nama: decryptedUser.nama,
            no_spm: pencairan.no_spm,
            opd: pencairan.nm_opd,
            status: 'Online'
        });
    }

    const updateProsesSP2D = (params) => {
        const db = getDatabase();
        set(ref(db, 'prosesSP2D'), params);
    }

    const deleteLoket = () => {
        const db = getDatabase();
        const dbRef = ref(db, "verifikasi/" + decryptedUser.nip)
        remove(dbRef).then(() => console.log("Deleted"))
    }

    return (

        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card>
                        <CardHeader
                            title={
                                <Typography variant='h5'>Cocokkan Dokumen Fisik dan Dokumen Online</Typography>
                            }
                            avatar={
                                <Tooltip title="Kembali">
                                    <IconButton variant="outlined" onClick={() => {
                                        navigate(-1)
                                    }} color="error"><ArrowBack /></IconButton>
                                </Tooltip>
                            }
                        // subheader="September 14, 2016"
                        />
                        <CardContent>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <ListItemText primary="No. SPM" secondary={pencairan.no_spm} />
                                        </TableCell>
                                        <TableCell>
                                            <ListItemText primary="No. SPP" secondary={pencairan.no_spp} />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <ListItemText primary="Tanggal SPM" secondary={pencairan.tgl_spm} />
                                        </TableCell>
                                        <TableCell>
                                            <ListItemText primary="Jenis Pencairan" secondary={pencairan.jenis + " " + pencairan.jenis_ls} />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <ListItemText primary="Keperluan" secondary={pencairan.keperluan} />
                                        </TableCell>
                                        <TableCell>
                                            <ListItemText primary="Anggaran" secondary={"Rp " + rP(pencairan.anggaran)} />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container spacing={2} py={2} px={{ lg: 5, md: 0 }} justifyContent="center">
                <Grid item xs={12} md={6}>
                    <Item className={classes.root}>
                        <Accordion expanded={true}>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                <Typography>Pengantar SP2D</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={
                                    base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/pengantar_sp2d/' + pencairan.file
                                } />
                            </AccordionDetails>
                        </Accordion>
                    </Item>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <Grid container spacing={2} direction="column">
                        <Grid item>
                            <Accordion expanded={true}>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                    <Typography>File SPM</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <iframe width='100%' height={700} title="Pdf" src={
                                        base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/spm/' + pencairan.file
                                    } />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        {
                            pencairan.jenis === "LS" && pencairan.jenis_ls === "Modal" &&
                            <>
                                <Grid item>
                                    <Accordion expanded={true}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Kontrak / Adendum</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/kontrak/' + pencairan.kontrak + '.pdf'
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item>
                                    <Accordion expanded={true}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Dokumentasi</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/dokumentasi/' + pencairan.file
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item>
                                    <Accordion expanded={true}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Progres</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/progres/' + pencairan.file
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item>
                                    <Accordion expanded={true}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Berita Acara</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/berita_acara/' + pencairan.file
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </>
                        }
                        {
                            pencairan.jenis_pencairan === "GU" &&
                            <Grid item>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                        <Typography>File SPJ Fungsional</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <iframe width='100%' height={700} title="Pdf" src={
                                            base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/spj_fungsional/' + pencairan.file
                                        } />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid container pt={2} spacing={2} justifyContent="space-between">
                <Grid item>
                    <LoadingButton
                        onClick={handleBatal}
                        loading={loading}
                        variant="outlined"
                        margin="normal"
                        loadingPosition="start"
                        startIcon={<Clear />}
                        color="error"
                    >
                        Batal Acc
                    </LoadingButton>
                </Grid>
                <Grid item>
                    <LoadingButton
                        onClick={handleSesuai}
                        loading={loading}
                        variant="contained"
                        margin="normal"
                        loadingPosition="start"
                        startIcon={<Save />}
                        endIcon={<ArrowForward />}
                    >
                        Sesuai
                    </LoadingButton>
                </Grid>
            </Grid>
        </Box>
    )
}

export default FormAcc